import { DeleteAccountReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';
const initialState: DeleteAccountReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};
const deleteAccountReducer = createReducer(initialState, {
  DELETE_ACCOUNT_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },
  DELETE_ACCOUNT_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },
  DELETE_ACCOUNT_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data;
  },
});
export default deleteAccountReducer;
